export default __webpack_public_path__ + "static/media/O-076.0475c2db.png";